module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-cca"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h5', {
    staticClass: "text-white text-center"
  }, [_vm._v("What are your interests?")]), _vm._v(" "), _c('div', {
    staticClass: "selection-row"
  }, _vm._l((_vm.ccasOffered), function(group) {
    return _c('div', {
      staticClass: "select-group"
    }, [_c('p', {
      staticClass: "text-secondary text-bold"
    }, [_vm._v(_vm._s(group.label))]), _vm._v(" "), _c('div', {
      staticClass: "select-one"
    }, _vm._l((group.ccas), function(cca) {
      return _c('label', {
        staticClass: "ellipsis text-primary"
      }, [_c('q-checkbox', {
        attrs: {
          "value": _vm.checked(cca)
        },
        on: {
          "input": function($event) {
            _vm.select(cca, $event)
          }
        }
      }), _vm._v("\n            " + _vm._s(cca.label) + "\n          ")], 1)
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "text-white text-bold button-right",
    on: {
      "click": function($event) {
        _vm.$emit('next')
      }
    }
  }, [_vm._v("next")]), _vm._v(" "), _c('button', {
    staticClass: "text-primary text-bold button-left",
    on: {
      "click": _vm.skip
    }
  }, [_vm._v("skip")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d9681b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d9681b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionView/Slide/Cca.vue
// module id = 848
// module chunks = 0